import { Routes } from '@angular/router';

import { authGuard, guestGuard } from './@core/authentication/guards/auth.guard';
import {
  legacyTenantPrefixMatcher,
  legacyTenantRedirectRoutes,
  stripTenantPrefixGuard,
} from './@core/authentication/guards/legacy-routing.guard';
import { roleHomeRedirectGuard } from './@core/authentication/guards/role.guard';
import { tenantFeatureRoutes } from './@features/features.routes';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'auth/login',
  },
  {
    path: 'reset-password',
    canActivate: [guestGuard],
    children: [
      {
        path: ':token',
        loadComponent: () =>
          import('./@features/auth/pages/reset-password/reset-password').then(
            (m) => m.ResetPassword,
          ),
      },
      {
        path: '',
        loadComponent: () =>
          import('./@features/auth/pages/reset-password/reset-password').then(
            (m) => m.ResetPassword,
          ),
      },
    ],
  },
  {
    path: 'billing/payment-result',
    loadComponent: () =>
      import('./@features/billing/pages/payment-result/payment-result').then(
        (m) => m.PaymentResult,
      ),
  },
  {
    path: 'auth',
    loadChildren: () =>
      import('./@features/auth/auth.route').then((m) => m.AuthRoutes),
  },
  {
    path: 'dashboard',
    pathMatch: 'full',
    canActivate: [roleHomeRedirectGuard],
    children: [],
  },
  {
    matcher: legacyTenantPrefixMatcher,
    canActivate: [stripTenantPrefixGuard],
    children: legacyTenantRedirectRoutes,
  },
  {
    path: '',
    loadComponent: () =>
      import('./@features/layouts/app-layout/app-layout.component').then(
        (m) => m.AppLayoutComponent,
      ),
    canActivate: [authGuard],
    canActivateChild: [authGuard],
    children: tenantFeatureRoutes,
  },
];
